export default __webpack_public_path__ + "static/media/11S.2dd738ea.webp";